<template>
  <el-card>
    <el-form :model="info" ref="info" :rules="rules" label-width="80px" class="global-form2">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="info.roleName" placeholder="请输入角色名称" maxlength="50" :disabled="info.roleCatalog==='1'"></el-input>
      </el-form-item>
      <el-form-item label="角色排序" prop="orderNum">
        <el-input v-model="info.orderNum" placeholder="请输入角色排序" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="角色说明" prop="description">
        <el-input type="textarea" show-word-limit v-model="info.description" placeholder="请输入角色说明" maxlength="200"></el-input>
      </el-form-item>
      <el-form-item label="数据权限" prop="dataPermission">
        <el-select v-model="info.dataPermission" placeholder="请选择数据权限">
          <el-option label="全部数据" value="1"></el-option>
          <el-option label="本人项目数据" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色权限" prop="menuList" class="menus">
        <div class='tree'>
          <div class='treeLeft'>
            <p class='treeName'>菜单权限</p>
            <el-tree
              :data="menuList"
              :props="props"
              :default-checked-keys="checkedKeys"
              show-checkbox
              node-key="menuId"
              default-expand-all
              @node-click="treeClick"
              @check-change="checkChange"
              @check="check"
              ref="tree">
              <span class="nodeItem" slot-scope="{ data }">
                <span :class="{ 'c-default': data.menuId === currentMenuId }">{{data.menuName}}</span>
              </span>
            </el-tree>
          </div>
          <div class="icon">
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class='treeRight'>
            <p class='treeName'>按钮权限</p>
            <div class='checkbox' v-if="buttonList && buttonList.length > 0">
              <el-checkbox class="checkbox-all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" :disabled="!isCurrentChecked">全选</el-checkbox>
              <el-checkbox v-model="item.isSelect" v-for="(item,index) in buttonList" :key="index"  @change="updateAllCheckedStatus" :disabled="!isCurrentChecked">{{item.butName}}</el-checkbox>
            </div>
          </div>
        </div>
        <div class='tree'>
          <div class='treeLeft'>
            <p class='treeName'>App菜单权限</p>
            <el-tree
              :data="menuAppList"
              :props="props"
              :default-checked-keys="checkedAppKeys"
              show-checkbox
              node-key="menuId"
              default-expand-all
              @node-click="treeAppClick"
              @check-change="checkAppChange"
              @check="appCheck"
              ref="AppTree">
              <span class="nodeItem" slot-scope="{ data }">
                <span :class="{ 'c-default': data.menuId === currentAppMenuId }">{{data.menuName}}</span>
              </span>
            </el-tree>
          </div>
          <div class="icon">
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class='treeRight'>
            <p class='treeName'>按钮权限</p>
            <div class='checkbox' v-if="buttonAppList && buttonAppList.length > 0">
              <el-checkbox class="checkbox-all" :indeterminate="isAppIndeterminate" v-model="checkAppAll" @change="handleCheckAllAppChange" :disabled="!isCurrentAppChecked">全选</el-checkbox>
              <el-checkbox v-model="item.isSelect" v-for="(item,index) in buttonAppList" :key="index"  @change="updateAllCheckedAppStatus" :disabled="!isCurrentAppChecked">{{item.butName}}</el-checkbox>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
        <el-button @click="$router.push({name:'role'})">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { pInteger } from '@/utils/validate'
export default {
  name: 'roleAdd',
  data () {
    return {
      info: {
        roleName: '',
        orderNum: 1,
        description: '',
        dataPermission: '1',
        menuList: [],
        appMenuList: []
      },
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: ['blur', 'change'] }],
        orderNum: [
          { required: true, message: '请输入角色排序', trigger: ['blur', 'change'] },
          { validator: pInteger, trigger: ['blur', 'change'] }
        ],
        dataPermission: [{ required: true, message: '请选择数据权限', trigger: ['change'] }],
        menuList: [
          { validator: this.validateMenu, trigger: ['blur', 'change'] }
        ]
      },
      menuList: [],
      checkedKeys: [],
      props: {
        value: 'menuId',
        children: 'childNode',
        label: 'menuName',
        disabled: (data) => {
          // 设置公用菜单置灰
          if (data.menuCommon === '1') {
            return true
          }
        }
      },
      menuAppList: [],
      checkedAppKeys: [],
      // 按钮权限
      buttonList: [],
      currentMenuId: '',
      isCurrentChecked: false,
      isIndeterminate: false,
      checkAll: false,
      buttonAppList: [],
      currentAppMenuId: '',
      isCurrentAppChecked: false,
      isAppIndeterminate: false,
      checkAppAll: false,
      submitShow: false
    }
  },
  computed: {
    roleId () {
      return this.$route.params.roleId || ''
    }
  },
  created () {
    this.menuGet()
    this.menuAppGet()
    if (this.roleId) {
      this.dataGet()
    } else {
      this.info.orderNum = Number(this.$route.params.orderNum) || 1
    }
  },
  methods: {
    // 详情数据
    dataGet () {
      this.$axios.get(this.$apis.system.roleDetail, {
        roleId: this.roleId
      }).then((res) => {
        this.info = {
          roleName: res.roleName || '',
          orderNum: res.orderNum || 1,
          description: res.description || '',
          dataPermission: res.dataPermission || '',
          menuList: res.menuList || [],
          appMenuList: res.appMenuList || [],
          roleId: res.roleId,
          roleCatalog: res.roleCatalog
        }
      })
    },
    // 菜单数据
    menuGet () {
      this.$axios.get(this.$apis.system.roleMenu, {
        roleId: this.roleId || null
      }).then((res) => {
        this.menuList = res || []
        this.checkedKeysSet(this.menuList)
      })
    },
    // APP菜单数据
    menuAppGet () {
      this.$axios.get(this.$apis.system.roleAppMenu, {
        roleId: this.roleId || null
      }).then((res) => {
        this.menuAppList = res || []
        this.menuAppList && this.checkedAppKeysSet(this.menuAppList)
      })
    },
    // 处理勾选数据
    checkedKeysSet (val) {
      val.forEach((item) => {
        if (item.childNode) {
          this.checkedKeysSet(item.childNode)
        } else {
          if (item.isSelect === '1') {
            this.checkedKeys.push(item.menuId)
          }
        }
      })
    },
    // 处理app勾选数据
    checkedAppKeysSet (val) {
      val.forEach((item) => {
        if (item.childNode) {
          this.checkedAppKeysSet(item.childNode)
        } else {
          if (item.isSelect === '1') {
            this.checkedAppKeys.push(item.menuId)
          }
        }
      })
    },
    // 当复选框被点击的时候触发（会优先执行checkChange，所以不需要做数据处理）
    check (data) {
      if (!data.childNode) {
        this.currentMenuId = data.menuId
        this.buttonList = data.button || []
        this.updateAllCheckedStatus()
      }
    },
    appCheck (data) {
      if (!data.childNode) {
        this.currentAppMenuId = data.menuId
        this.buttonAppList = data.button || []
        this.updateAllCheckedAppStatus()
      }
    },
    // 节点选中状态发生变化时(优先于check执行），主菜单变更会触发子菜单变更（主菜单变更会调用多次）
    checkChange (data, check) {
      if (!data.childNode) {
        const buttonList = data.button || []
        data.button = buttonList.map(item => {
          item.isSelect = check
          return item
        })
        if (data.menuId === this.currentMenuId) {
          this.updateAllCheckedStatus()
        }
      }
    },
    checkAppChange (data, check) {
      if (!data.childNode) {
        const buttonList = data.button || []
        data.button = buttonList.map(item => {
          item.isSelect = check
          return item
        })
        if (data.menuId === this.currentAppMenuId) {
          this.updateAllCheckedAppStatus()
        }
      }
    },
    // 菜单被点击
    treeClick (data) {
      if (!data.childNode) {
        this.currentMenuId = data.menuId
        this.buttonList = data.button || []
        this.updateAllCheckedStatus()
      }
    },
    treeAppClick (data) {
      if (!data.childNode) {
        this.currentAppMenuId = data.menuId
        this.buttonAppList = data.button || []
        this.updateAllCheckedAppStatus()
      }
    },
    // 更改按钮权限全选状态
    updateAllCheckedStatus () {
      const checkedKeys = this.$refs.tree.getCheckedKeys(true)
      this.isCurrentChecked = checkedKeys.findIndex(item => item === this.currentMenuId) >= 0
      let checkedCount = 0
      this.buttonList.forEach(item => {
        if (item.isSelect) {
          checkedCount++
        }
      })
      this.checkAll = checkedCount === this.buttonList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.buttonList.length
    },
    // 更改app按钮权限全选状态
    updateAllCheckedAppStatus () {
      const checkedKeys = this.$refs.AppTree.getCheckedKeys(true)
      this.isCurrentAppChecked = checkedKeys.findIndex(item => item === this.currentAppMenuId) >= 0
      let checkedCount = 0
      this.buttonAppList.forEach(item => {
        if (item.isSelect) {
          checkedCount++
        }
      })
      this.checkAppAll = checkedCount === this.buttonAppList.length
      this.isAppIndeterminate = checkedCount > 0 && checkedCount < this.buttonAppList.length
    },
    // 按钮全选或全不选
    handleCheckAllChange (val) {
      if (val) {
        this.buttonList = this.buttonList.map(item => {
          item.isSelect = true
          return item
        })
      } else {
        this.buttonList = this.buttonList.map(item => {
          item.isSelect = false
          return item
        })
      }
      this.isIndeterminate = false
    },
    handleCheckAllAppChange (val) {
      if (val) {
        this.buttonAppList = this.buttonAppList.map(item => {
          item.isSelect = true
          return item
        })
      } else {
        this.buttonAppList = this.buttonAppList.map(item => {
          item.isSelect = false
          return item
        })
      }
      this.isAppIndeterminate = false
    },
    validateMenu (rule, value, callback) {
      if (this.info.menuList.length === 0) {
        callback(new Error('请勾选菜单权限'))
      } else {
        return callback()
      }
      //  else if (this.info.appMenuList.length === 0) {
      //   callback(new Error('请勾选App菜单权限'))
      // }
    },
    onSubmit () {
      this.info.menuList = []
      this.info.appMenuList = []
      // 获取已勾选菜单
      const checkList = this.$refs.tree.getCheckedNodes(false, true)
      checkList.forEach((item) => {
        const buttonList = []
        if (item.button) {
          item.button.forEach((buttonItem) => { // 按钮权限
            if (buttonItem.isSelect) {
              buttonList.push({ butCode: buttonItem.butCode })
            }
          })
        }
        this.info.menuList.push({
          menuId: item.menuId,
          button: buttonList
        })
      })
      // 获取已勾选app菜单
      const checkAppList = this.$refs.AppTree.getCheckedNodes(false, true)
      checkAppList.forEach((item) => {
        const buttonList = []
        if (item.button) {
          item.button.forEach((buttonItem) => { // 按钮权限
            if (buttonItem.isSelect) {
              buttonList.push({ butCode: buttonItem.butCode })
            }
          })
        }
        this.info.appMenuList.push({
          menuId: item.menuId,
          button: buttonList
        })
      })
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.save()
        }
      })
    },
    save () {
      this.submitShow = true
      const url = this.roleId ? this.$apis.system.roleUpdate : this.$apis.system.roleAdd
      this.$axios.post(url, this.info).then(() => {
        this.$message.success('保存成功')
        this.$router.push({ name: 'role' })
      }).catch(() => {
        this.submitShow = false
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .menus {
  .el-form-item__content {
    display: flex;
  }
}
.tree{
  display: flex;
  margin-right: 50px;
  .treeLeft{
    border: 1px solid #E1E1E1;
    min-width:220px;
    .el-tree{
      padding:16px 24px 24px 24px;
      max-height: 400px;
      overflow-y: auto;
      ::v-deep .el-tree-node{
        padding: 3px 0;
      }
      ::v-deep .el-tree-node__content:hover{
        background-color:rgba(255, 255, 255, 0);
      }
      ::v-deep .is-current{
        .el-tree-node__content{
          background-color:rgba(255, 255, 255, 0) !important;
        }
      }
      .nodeItem{
        width: 100%;
        padding:0 5px;
      }
      .nodeItem:hover{
        background-color: #E8FAF7 !important;
        color: #ffffff;
      }
    }
  }
  .treeRight{
    border: 1px solid #E1E1E1;
    min-width:200px;
    .checkbox {
      display:flex;
      flex-direction:column;
      padding:20px 0 0 24px;
      .checkbox-all {
        margin-bottom: 20px;
      }
    }
  }
  .treeName{
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    background-color: #F6FDFC;
    border-bottom: 1px solid #E1E1E1;
  }
  .icon{
    display: flex;
    align-items: center;
    i{
      background-color:#E1E1E1;
      color: #fff;
      margin: 0 24px;
      padding: 2px 5px;
    }
  }
}
</style>
